export default __webpack_public_path__ + "static/media/error.a957e749.svg";